import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCalendarAltSvg } from "./IconCalendarAltSvg.mjs";
const IconCalendarAlt = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCalendarAltSvg, ...iconProps });
};
export {
  IconCalendarAlt
};
